module.exports = __webpack_public_path__ + "img/getBoarded.45b254ab.svg";